import {useVisibilityStylesBuilder} from '../../../commons/hooks/use-visibility-styles-builder'
import {StyleSelectors} from '../style-selectors'

export const useVisibilityStyles = () => useVisibilityStylesBuilder(StyleSelectors)
